import React from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { TransformationSection } from '../components/landing/TransformationSection';
import { ProductFeatures } from '../components/landing/ProductFeatures';
import { BenefitsGrid } from '../components/landing/BenefitsGrid';
import { Testimonials } from '../components/landing/Testimonials';
import { ComparisonTable } from '../components/landing/ComparisonTable';
import { CTASection } from '../components/landing/CTASection';
import { RiskReversal } from '../components/landing/RiskReversal';
import { FAQSection } from '../components/landing/FAQSection';
import { Footer } from '../components/landing/Footer';
import { RecentPurchases } from '../components/landing/RecentPurchases';
export function LandingPage() {
  return <>
      {/* Social proof notification */}
      <RecentPurchases data-id="element-570" />

      {/* Optimized premium flow */}
      <HeroSection data-id="element-571" />
      <ProblemSection data-id="element-572" />
      <TransformationSection data-id="element-573" />
      <ProductFeatures data-id="element-574" />
      <BenefitsGrid data-id="element-575" />
      <Testimonials data-id="element-576" />
      <ComparisonTable data-id="element-577" />
      <CTASection data-id="element-578" />
      <RiskReversal data-id="element-579" />
      <FAQSection data-id="element-580" />
      <Footer data-id="element-581" />
    </>;
}